<div class="content-wrapper">
  <div class="row">
    <div class="col-12 grid-margin stretch-card">
      <div class="card">
        <div class="card-body">
          <h4 class="card-title">Create New System User</h4>
          <form class="forms-sample" #ngNewLocationForm="ngForm" name="form"
            (ngSubmit)="onSubmit()" >

            <div class="row">
              <!-- Name -->
              <div class="col">
                <div class="form-group">
                  <label for="name">First Name</label>
                  <input type="text" class="form-control" id="firstname" placeholder="ex: John" name="firstname"
                    [(ngModel)]="firstname" required>
                </div>
              </div>

              <!-- Lastname -->
              <div class="col">
                <div class="form-group">
                  <label for="lastname">Last Name</label>
                  <input type="text" class="form-control" id="lastname" placeholder="ex: John" name="lastname"
                    [(ngModel)]="lastname" required>
                </div>
              </div>
            </div>

            <div class="row">
              <!-- Email  -->
              <div class="col">
                <div class="form-group">
                  <label for="email">Email</label>
                  <input type="text" class="form-control" id="email" placeholder=" " name="email" [(ngModel)]="email"
                    required>
                </div>
              </div>

              <!-- SAP  -->
              <div class="col">
                <div class="form-group">
                  <label for="sapId">SAP Id</label>
                  <input type="text" class="form-control" id="sapId" placeholder=" " name="sapId"
                    [(ngModel)]="sapId" required>
                </div>
              </div>

              <!-- Phone  -->
              <div class="col">
                <div class="form-group">
                  <label for="phoneNumber">Phone Number</label>
                  <input type="text" class="form-control" id="phoneNumber" placeholder=" " name="phoneNumber"
                    [(ngModel)]="phoneNumber" required>
                </div>
              </div>
            </div>
              
            <!-- </div> -->

         
            <div class="row">
			
              <!-- Location  -->
                    <div class="col">
                      <div class="form-group">
                        <label for="selectedLocation">Location</label>
                        <select class="form-control" required [(ngModel)]="selectedLocationId" name="selectedLocationId"
                          id="selectedLocationId">
                          <option value="">-- Select Location --</option>
                          <option [value]="location.id" *ngFor="let location of Locations">{{location.name}}
                          </option>
                        </select>
                      </div>
                    </div>
      
      
      
                    <!-- Department  -->
                    <div class="col">
                      <div class="form-group">
                        <label for="selectedDepartment">Department</label>
                        <select class="form-control" required [(ngModel)]="selectedDepartmentId" name="selectedDepartmentId"
                          id="selectedDepartmentId"  (ngModelChange)="onChangeDepartment($event)">
                          <option value="">-- Select Department --</option>
                          <option [value]="department.id" *ngFor="let department of Departments">{{department.name}}
                          </option>
                        </select>
                      </div>
                    </div>
      
                    <!-- Function  -->
                    <div class="col">
                      <div class="form-group">
                        <label for="selectedDepartment">Function</label>
                     
                        <ng-select  required [(ngModel)]="selectedFunctionId"  id="selectedFunctionId" name="selectedFunctionId">
                          <ng-option *ngFor="let function of Functions" [value]="function.id">
                            {{function.name}}</ng-option>
                        </ng-select>



                      </div>
                    </div>
                     
                   
                  </div>
                <!-- approval designation  -->        
		<div class="row">
		
                 
                    <div class="col">
                      <div class="form-group">
                        <label for="exampleSelectDesignation">Approval Designation</label>
                        <select class="form-control" required [(ngModel)]="selectedDesignationId" name="selectedDesignationId"
                          id="selectedDesignationId"    (ngModelChange)="onChangeDesignation($event)">
                          <option value="">-- Select Designation --</option>
                          <option [value]="designation.id" *ngFor="let designation of Designations">{{designation.name}}
                          </option>
                        </select>
                      </div>
                    </div>
		</div>
           <!-- MManager - Nplus1 -->        
           <div class="row" *ngIf="isManagerVisible">
		
                 
            <div class="col">
              <div class="form-group">
                <label for="exampleSelectDesignation">Manager</label>
             
                <ng-select  required [(ngModel)]="selectedManagerId"  id="selectedManagerId" name="selectedManagerId">
                  <ng-option *ngFor="let manager of Managers" [value]="manager.id">
                    {{manager.firstName}} -   {{manager.email}}</ng-option>
                </ng-select>


              </div>
            </div>
</div>

            <div class="row">
             <!-- Role  -->
                    <div class="col">
                     
                        <label for="exampleSelectRole">Role</label>

                       
                       <!--
                        <select class="form-control" required [(ngModel)]="selectedRoleId" name="selectedRoleId"
                          id="selectedRoleId">
                          <option value="">-- Select role --</option>
                          <option [value]="role.id" *ngFor="let role of Roles">{{role.roleName}} </option>
                        </select>

                      -->
                   
                    </div>
                 
            </div>
            <div class="row">
              <div class="col">
                <div class="form-group"  [formGroup]="groupForm">
                <p-multiSelect [options]="allowedRoles"  defaultLabel="Select a Role" optionLabel="roleName" selectedItemsLabel="{0} roles selected" formControlName="selectedRoles" id="selectedRoles" ></p-multiSelect>
                </div>
              </div>
             
            </div>
            <button type="submit" class="btn btn-primary mr-2" >Submit</button>
            <button class="btn btn-light">Cancel</button>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>